<template>
  <article class="single-post" :id="post._id">
    <div class="post-tools">
      <button class="shrink-post" @click="$emit('shrink')">
        <i class="fas fa-caret-down"></i>
      </button>
      <button
        v-if="thisUser._id === post.author[1] || thisUser.isAdmin"
        @click="deletePost()"
      >
        <i class="fas fa-trash"></i>
      </button>
    </div>
    <h4>
      <i class="admin-badge" v-if="post.author[3] === 'Admin'"></i>
      {{ post.author[0] }}
    </h4>
    <w-d-text :text="post.text"></w-d-text>
    <div class="likes-comments">
      <button class="likes">
        <input
          type="checkbox"
          :id="post._id + '-like-button'"
          @change="editLikes($event)"
          :checked="post.likes.includes(thisUser.name)"
        />
        <label :for="post._id + '-like-button'"></label>
        <span>{{ post.likes.length }}</span>
      </button>
      <button class="comments" @click="fetchComments()">
        <i class="far fa-comment"></i>
        {{ post.commentsNumber }}
      </button>
      <span class="topic" @click="this.$emit('change-topic', post.topic)">{{
        $store.state.appVocubulary[$store.state.lang].public.interests[
          post.topic
        ]
      }}</span>
    </div>
    <transition name="opacity">
      <w-popup ref="popup" />
    </transition>
    <section class="comment-section">
      <w-comment
        v-for="comment in comments"
        :key="comment._id"
        :commentObject="JSON.stringify(comment)"
        @refresh="refreshPost()"
        @reply-to="reply"
      >
        <section>
          <w-comment
            v-for="reply in comment.replies"
            :key="reply._id"
            :commentObject="JSON.stringify(reply)"
            @refresh="refreshPost()"
            :parentComment="comment._id"
          ></w-comment>
        </section>
      </w-comment>
    </section>
  </article>
</template>

<script>
import axios from "axios";
import WPopup from "./WPopup.vue";
import WComment from "./WComment.vue";
import WDText from "./WDText.vue";
export default {
  name: "WPost",
  components: { WPopup, WComment, WDText },
  props: ["postData", "thisUserId", "thisUserName"],
  data() {
    return {
      post: JSON.parse(this.postData),
      comments: [],
    };
  },
  computed: {
    thisUser() {
      return this.$store.state.user;
    },
    lang() {
      return this.$store.state.lang;
    },
    appVocubulary() {
      return this.$store.state.appVocubulary[this.lang].pages.Posts;
    },
  },
  methods: {
    reply(replyText) {
      this.$emit("reply-to", replyText);
    },
    async refreshPost() {
      const refreshed = await axios.get(
        `${this.$store.state.backend_link}posts/${this.post._id}`
      );
      this.post = refreshed.data;
      this.fetchComments();
    },
    async fetchComments() {
      this.$emit("expand");
      let fetched = await axios.get(
        `${this.$store.state.backend_link}comments/${this.post._id}`
      );
      this.comments = fetched.data;
    },
    async deletePost() {
      const confirmationResult = await this.$refs.popup.show({
        message: this.appVocubulary.deletePost,
        confirmText: "DELETE",
        cancelText: "CANCEL",
      });
      if (confirmationResult) {
        axios.delete(`${this.$store.state.backend_link}posts/${this.post._id}`);
        this.$emit("fetch-posts");
        this.$emit("fetch-posts");
      }
    },
    async editLikes(e) {
      let likesCheck = e.currentTarget.parentElement.childNodes[0],
        likesText = e.currentTarget.parentElement.childNodes[2];
      const operation = likesCheck.checked ? "plus" : "minus";
      if (operation === "plus") {
        likesText.textContent = Number.parseInt(likesText.textContent) + 1;
      } else {
        likesText.textContent = Number.parseInt(likesText.textContent) - 1;
      }
      const post = await axios.put(
        `${this.$store.state.backend_link}posts/${this.post._id}`,
        {
          name: this.thisUser.name,
          operation: operation,
        }
      );
      if (operation === "plus") {
        likesText.textContent = post.data.likes.length + 1;
      } else {
        likesText.textContent = post.data.likes.length - 1;
      }
    },
  },
};
</script>

<style lang="scss">
.single-post {
  position: relative;
  width: 100%;
  min-height: 156px;
  max-width: 800px;
  background-color: var(--bg2);
  border-radius: 4px;
  padding: 10px 10px 0;
  margin: 10px auto;

  .post-tools {
    position: absolute;
    top: 4px;
    right: 16px;
    button {
      background-color: transparent;
      color: var(--text);
      padding: 4px;
      margin: 10px 8px;
      &.shrink-post {
        display: none;
      }
    }
  }

  .w-input {
    display: none;
  }

  .comment-section {
    direction: ltr;
    display: none;
    background: var(--bg);
    min-height: 200px;
    border-radius: 10px;
    padding: 10px;
    overflow: auto;
  }

  &.expanded-post {
    z-index: 8;
    height: 100vh;
    max-width: 100%;
    position: fixed;
    top: 0;
    left: 0;
    padding-bottom: 140px;
    animation: expand-post forwards 0.4s ease;
    overflow: auto;
    .comment-section {
      display: block;
    }
    .w-input {
      display: flex;
    }
    .shrink-post {
      display: inline-block !important;
    }
  }

  &.shrinked-post {
    animation: shrink-post forwards 0.4s ease;
    position: relative;
    top: 0;
  }

  .likes-comments {
    font-size: 1.1em;
    width: 100%;
    height: 50px;
    display: grid;
    grid-template-columns: 80px 80px auto;
    justify-items: start;
    align-items: center;

    .topic {
      width: fit-content;
      height: fit-content;
      color: var(--text);
      font-weight: bold;
      border: 2px solid var(--accent);
      border-radius: 40px;
      padding: 6px 12px;
      font-size: 0.6em;
      justify-self: end;
      cursor: pointer;
      &:hover {
        background-color: var(--accent);
        color: white;
      }
    }

    button {
      font-size: 0.8em;
      font-weight: bold;
      background-color: transparent;
      color: var(--text);
      padding: 10px;
      height: 100%;
      margin: 0;
      padding: 0 10px;
      cursor: pointer;
      i {
        margin: 0 10px;
      }

      &.likes {
        label {
          margin: 0 10px;
          color: white;
          &:before {
            content: "\f004";
            color: var(--text);
            font-weight: 400;
            font-family: "Font Awesome 5 Free";
            transition: all 0.2s linear;
          }
        }
        & > input {
          display: none;
          &:checked + label {
            &:before {
              color: red;
              font-weight: 900;
            }
          }
        }
      }
    }
  }

  h4 {
    text-align: left;
    margin: 10px 14px;
  }
}

@keyframes expand-post {
  0% {
    top: 50vh;
  }
  100% {
    top: 0;
  }
}

@keyframes shrink-post {
  0% {
    top: 80px;
  }
  100% {
    top: 0vh;
  }
}
</style>
